
import React, { useState, useEffect } from 'react'
import { Row, Col, Card, CardBody, Form, FormGroup, Label, Input, Button, Spinner } from 'reactstrap';

import ResponseBox from './ResponseBox';

import { patchUser } from '../../helpers/satiBack';

const ChangePassword = () => {
  const [pass, setPass] = useState('');
  const [confirm, setConfirm] = useState('');
  const [valid, setValid] = useState(false);
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(0);

  useEffect(() => {
    if (pass === "" || confirm === "") {
      setValid(false);
    } else {
      setValid(pass === confirm);
    }
  }, [pass, confirm]);

  const handlePassChange = (e) => {
    setPass(e.target.value.trim());
  }

  const handleConfirmChange = (e) => {
    setConfirm(e.target.value.trim());
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setResponse(0);

    const { pass } = e.target.elements;
    const data = {
      password: pass.value
    };

    patchUser(data)
      .then(resp => {
        setResponse(1);
        setTimeout(() => {
          window.location.replace('/logout');
        }, 2000);
      })
      .catch(err => {
        setLoading(false);
        setResponse(2);
      })
  }

  return (
    <Card>
      <CardBody>
        <h4>Cambiar contraseña</h4>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label for="pass">Contraseña</Label>
            <Input
              type='password'
              name='pass'
              id='pass'
              placeholder='Nueva contraseña'
              value={pass}
              onChange={handlePassChange}
            />
          </FormGroup>
          <FormGroup>
            <Input
              type='password'
              name='confirm'
              id='confirm'
              placeholder='Confirmar contraseña'
              value={confirm}
              onChange={handleConfirmChange}
            />
          </FormGroup>
          <ResponseBox type={response} response="Cerrando sesión..."/>
          <Row>
            <Col>
              {confirm !== "" && !valid && (
                <span className="text-danger float-left">La contraseña no coincide</span>
              )}
              <Button type="submit" className="float-right btn btn-primary" style={{color: valid && "white"}} disabled={!valid}>
                Guardar
                {loading && (<Spinner size="sm" color="light" className="ml-2"/>)}
              </Button>
            </Col>
          </Row>
        </Form>
      </CardBody>
    </Card>
  )
}

export default ChangePassword;
